export default __webpack_public_path__ + "assets/images/15c6ed883cb64db59de34c2e58168e65.png";